import PageTitle from 'components/ui/pageTitle/pageTitle'
import React from 'react'
import AllRestaurantsSection from './components/allRestaurantsSection/allRestaurantsSection'

export default function Restaurants() {
  return (
    <>
      <PageTitle>Restaurants</PageTitle>
      <AllRestaurantsSection />
    </>
  )
}
